import type { Tabs } from './types'

export const ACCOUNT_ACTIVITY_ROUTE = 'account/activity'

export const ACCOUNT_ACTIVITY_PENDING_ROUTE: RouteWithTab = `${ACCOUNT_ACTIVITY_ROUTE}/pending`

export const ACCOUNT_ACTIVITY_RESULTS_ROUTE: RouteWithTab = `${ACCOUNT_ACTIVITY_ROUTE}/results`

type RouteWithTab = `${string}/${Tabs}`
